import api from "./api";

const CollaboratorService = {
  getAllToReport: async () => {
    const { data } = await api.get("/api/collaborators/all/");
    return data;
  },
};

export default CollaboratorService;
